import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        A new complex for 325 post-graduate bedrooms for the University of
        Cambridge, as part of the North West Cambridge urban expansion project.
      </p>
      <p>
        The layout of the site reinterprets the tradition of collegiate
        Cambridge Colleges, by creating three open courts to reflect the open
        and engaging approach to urban design adopted across the North West
        Cambridge masterplan.
      </p>
      <p>
        Bedrooms are arranged into 15 ‘houses’, each with large social spaces
        for whole house gatherings, and additional kitchen and dining areas for
        each floor of every house. The Porter’s Lodge area includes seating,
        study and laundry facilities, providing a wide range of social spaces
        across the site.
      </p>
      <p>
        Extensive red-brickwork references buildings in Norwich generally, but
        specifically the interesting housing development at The Lathes nearby,
        while a curved red-brick facade to the junction with Oak Street adds a
        new architectural detail to the local vernacular.
      </p>
      <p className="ps">
        This project was completed while Matt was with RH Partnership Architects
        in Cambridge
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/cambridge-student-accommodation.jsx